// extracted by mini-css-extract-plugin
module.exports = {"table":"simpleTable_table__19b1o","headerGroup":"simpleTable_headerGroup__1jj7z","stickyHeader":"simpleTable_stickyHeader__16hVm"};